import { render, staticRenderFns } from "./NewPayment.vue?vue&type=template&id=4539114d&"
import script from "./NewPayment.vue?vue&type=script&lang=ts&"
export * from "./NewPayment.vue?vue&type=script&lang=ts&"
import style0 from "./NewPayment.vue?vue&type=style&index=0&lang=sass&scope=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports